import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";

import { Observable, EMPTY } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/reducers";

import { AppSessionService } from "../app-session/app-session.service";

import { UserSession } from "src/app/models/user-session";
import {PasswordRecoveryDTO} from "../../../models/login/PasswordRecoveryDTO";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  private BASE_URL = this.appSession.baseUrl + "/oauth";

  private REDIRECT_URI = "http://localhost:4200/dashboard";
  private CLIENT_ID = "PETROTEC";
  private SCOPE = "read";

  constructor(
    private router: Router,
    private http: HttpClient,
    private store: Store<AppState>,
    private appSession: AppSessionService
  ) {}

  logOutSuccess(action): Observable<any> {
    localStorage.clear();

    if (!action.isPasswordRecovery) {
      this.router.navigate(["/login"]);
    }
    return EMPTY;
  }

  logOut(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const url = `${this.appSession.baseUrl}/oauth/logout`;

    return this.http.post<UserSession>(url, null, { headers });
  }

  logIn(action: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
      Authorization:
        "Basic " + btoa("PETROTEC:fe7dfe5a21ac4f42b389aa00f1ab2ef530516d28"),
    });
    localStorage.setItem("username", action.user.id);
    const data =
      "grant_type=password&client_id=" +
      this.CLIENT_ID +
      "&scope=" +
      this.SCOPE +
      "&username=" +
      action.user.id +
      "&password=" +
      encodeURIComponent(action.user.password);

    const url = `${this.appSession.baseUrl + "/oauth"}/token`;
    return this.http.post<UserSession>(url, data, { headers });
  }

  refreshToken(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
        Authorization:
          "Basic " + btoa("PETROTEC:fe7dfe5a21ac4f42b389aa00f1ab2ef530516d28"),
      }),
    };

    const params = new HttpParams({
      fromObject: {
        grant_type: "refresh_token",
        scope: "read",
        refresh_token: localStorage.getItem("refresh_token"),
      },
    });

    return this.http
      .post<UserSession>(
        `${this.appSession.baseUrl + "/oauth"}/token`,
        params,
        httpOptions
      )
      .pipe(
        map((response) => {
          localStorage.setItem("access_token", response.access_token);
          localStorage.setItem("refresh_token", response.refresh_token);
          return response;
        }),
        catchError((error) => {
          let date = new Date();

          throw date.toUTCString();
        })
      );
  }

  recoverPassword(passwordRecovery : PasswordRecoveryDTO ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const data = JSON.stringify(passwordRecovery);
    const url = `${this.appSession.baseUrl}/api/v1/users/passwordRecovery`;

    return this.http.post(url, data, { headers });
  }

  resetPassword(action): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const data = JSON.stringify(action.passwordReset);
    const tokenQuery = action.tokenQuery;
    const url = `${this.appSession.baseUrl}/api/v1/users/finishPasswordRecovery${tokenQuery}`;

    return this.http.put(url, data, { headers });
  }
}
